<template>
    <v-container pt-5 fluid style="color:black" class="policeLato">
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mb-5">
            <div style="padding-left: 10.5%;padding-right:10.5%">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop">{{ $t('apropos.question_title') }}</h1>
                    </div>
                    <div class="justify-content-center row mt-2 mb-5">
                        <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                    </div>
                </div>

                <div id="popup" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.8); justify-content:center; align-items:center;">
    <img id="popup-img" src="" style="max-width:90%; max-height:90%;">
</div>

                <div class="row">
                    <div class="col-sm-6">
                        <div>
                            <div class="accordion" v-if="step === 0">
                                <!-- FAQ 1 -->
                                <div class="accordion-item">
                                <button id="accordion-button-1" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_label') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                        {{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_content[0]') }} <br>
                                        1 - {{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_content[1]') }} <br>
                                        2 - {{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_content[2]') }} "<span>{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_content[3]') }}</span>" <br>
                                        3 - {{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.question_one_content[4]') }} <br>

                                        <img src="../../assets/img/format_1.png" alt="format_change" width="80%">
                                        <img src="../../assets/img/format_2.png" alt="format_change" width="80%">
                                        
                                        <!-- <img onclick="showImage ('../../assets/img/askia.png')" src="../../assets/img/askia.png" alt="format_change" width="50"> -->

                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 2 -->
                                <div class="accordion-item">
                                <button id="accordion-button-2" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.second_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                        {{ $t('apropos.second_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.second_question_content[1]') }}</b>{{ $t('apropos.second_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.second_question_content[3]') }}</b>
                                                                    {{ $t('apropos.second_question_content[4]') }} <b style="color:#ffa409">{{ $t('apropos.second_question_content[5]') }}</b> {{ $t('apropos.second_question_content[6]') }}
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 3 -->
                                <div class="accordion-item">
                                <button id="accordion-button-3" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.third_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.third_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.third_question_content[1]') }}</b> {{ $t('apropos.third_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.third_question_content[3]') }}</b> 
                                                                    {{ $t('apropos.third_question_content[4]') }}
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 4 -->
                                <div class="accordion-item">
                                <button id="accordion-button-4" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.four_question_title[0]') }} <b style="color:#ffa409">{{ $t('apropos.four_question_title[1]') }}</b> {{ $t('apropos.four_question_title[2]') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.four_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.four_question_content[1]') }} </b> {{ $t('apropos.four_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.four_question_content[3]') }} </b> 
                                                                    {{ $t('apropos.four_question_content[4]') }}
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 5 -->
                                <div class="accordion-item">
                                <button id="accordion-button-5" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.five_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.five_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.five_question_content[1]') }} </b> {{ $t('apropos.five_question_content[2]') }} 
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 6 -->
                                <div class="accordion-item">
                                <button id="accordion-button-1" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.six_question_title[0]') }}  <b style="color:#ffa409">{{ $t('apropos.six_question_title[1]') }} </b> {{ $t('apropos.six_question_title[2]') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>{{ $t('apropos.six_question_content[0]') }}  <b style="color:#ffa409">{{ $t('apropos.six_question_content[1]') }}</b> 
                                                                    {{ $t('apropos.six_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.six_question_content[3]') }}</b>,
                                                                    {{ $t('apropos.six_question_content[4]') }} <b style="color:#ffa409">{{ $t('apropos.six_question_content[5]') }}</b> {{ $t('apropos.six_question_content[6]') }}
                                                                    <b style="color:#ffa409">{{ $t('apropos.six_question_content[7]') }}</b> {{ $t('apropos.six_question_content[8]') }}</p>
                                </div>
                                </div>
                            </div>
                            <div class="accordion" v-if="step === 1">
                                  <!-- FAQ 7 -->
                                <div class="accordion-item">
                                <button id="accordion-button-2" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.seven_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                        {{ $t('apropos.seven_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.seven_question_content[1]') }}</b> {{ $t('apropos.seven_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.seven_question_content[3]') }}</b>.
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 8 -->
                                <div class="accordion-item">
                                <button id="accordion-button-3" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.eight_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.eight_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.eight_question_content[1]') }}</b> 
                                                                    {{ $t('apropos.eight_question_content[2]') }}
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 9 -->
                                <div class="accordion-item">
                                <button id="accordion-button-4" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.nine_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.nine_question_content[0]') }}
                                    </p>
                                </div>
                                </div>
                                  <!-- FAQ 10 -->
                                <div class="accordion-item">
                                <button id="accordion-button-5" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.ten_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.ten_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.ten_question_content[1]') }}</b> {{ $t('apropos.ten_question_content[2]') }}
                                                                    <br> {{ $t('apropos.ten_question_content[3]') }} (<b style="color:#ffa409">{{ $t('apropos.ten_question_content[4]') }}</b>), {{ $t('apropos.ten_question_content[5]') }} (<b style="color:#CD1E26">{{ $t('apropos.ten_question_content[6]') }}</b>)
                                                                    {{ $t('apropos.ten_question_content[7]') }} (<b><a @click="wave_qr_code = true" style="color: #12B9EE">{{ $t('apropos.ten_question_content[8]') }}</a></b>).<br>
                                                                    {{ $t('apropos.ten_question_content[9]') }} 
                                    </p>
                                </div>
                                </div>
                                <!-- FAQ 11 -->
                                <div class="accordion-item">
                                <button id="accordion-button-1" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.eleven_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>{{ $t('apropos.eleven_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.eleven_question_content[1]') }}</b> {{ $t('apropos.eleven_question_content[2]') }}</p>
                                </div>
                                </div>
                                  <!-- FAQ 12 -->
                                <div class="accordion-item">
                                <button id="accordion-button-2" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.twelve_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>{{ $t('apropos.twelve_question_content[0]') }}
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="accordion" v-if="step === 2">
                                  <!-- FAQ 13 -->
                                <div class="accordion-item">
                                <button id="accordion-button-3" aria-expanded="false">
                                    <span class="accordion-title">{{ $t('apropos.thirteen_question_title') }}</span>
                                    <span class="icon" aria-hidden="true"></span>
                                </button>
                                <div class="accordion-content">
                                    <p>
                                    {{ $t('apropos.thirteen_question_content[0]') }} <b style="color:#ffa409">{{ $t('apropos.thirteen_question_content[1]') }}</b>{{ $t('apropos.thirteen_question_content[2]') }} <b style="color:#ffa409">{{ $t('apropos.thirteen_question_content[3]') }}</b>
                                                                    {{ $t('apropos.thirteen_question_content[4]') }} <b style="color:#ffa409">{{ $t('apropos.thirteen_question_content[5]') }}</b>
                                    </p>
                                </div>
                                </div>
                            </div>
                        </div>

                        <div class="justify-content-center pagination mt-5">
                            <button @click="previousQuestion" :style="{ background: step === 0 ? '#ffead8' : '#ffa409' }">❮</button>
                            <button class="ml-2"
                                @click="nextQuestion"
                                :style="{ background: step === 2 ? '#ffead8' : '#ffa409' }"
                            >❯</button>
                        </div>
                    </div>
                    <div class="col-sm-1">

                    </div>
                    <div class="col-sm-5">
                         <div class="justify-content-center column" style="margin-top:10%">
                            <div>
                                 <div class="fields">
                                    <div class="text-center">
                                        <h1 class="mt-5">{{ $t('apropos.Question_label') }}</h1>
                                    <p style="font-weight:500!important">{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.poser_question_label') }}</p>
                                    </div>
                                    <div class="mt-5 row">
                                        
                                    </div>
                                        <div class="row">
                                        <div class="col-sm-12">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <div style="display: flex; align-items: center;width: 100%!important;">
                                                    <select v-model="user.countryCode" class="intl_number">
                                                        <option style="padding: 10px!important;" v-for="item in intlNumberData" :key="item" :value="item.code">
                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                        </option>
                                                    </select>
                                                    <span style="margin-left: -15px;margin-top: -30px; pointer-events: none; color: black; font-size: 10px;">&#9660;</span>
                                                    <input style="margin-left: 5px;" @keypress="onlyNumber" v-model="user.telephone" type="number" name="email" id="email_input" :placeholder="$t('apropos.question_form_input_number_placeholder_content')">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <textarea v-model="user.question" id="email_input" :placeholder="$t('apropos.question_form_input_question_placeholder_content')" rows="4" style="width: 100%; resize: vertical; border-radius: 10px; padding: 15px; background-color: #FEFBF6; color: #000; border: 1px solid #e5e5e5; font-size: 16px; margin-bottom: 30px;"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="justify-content-center row notfound">
                                          <a :disabled="!chatReady" href="javascript:void(0)" @click="sendQuestion()">{{ $t('contact.bouton_envoye') }}</a>
                                    </div>

                                   
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- popup pour scanner qrcode wave pour wave -->
      <!-- popup pour scanner qrcode wave pour wave -->
      <v-dialog v-model="wave_qr_code" max-width="420" max-height="700">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <img width="400" height="600" src="../../assets/img/logoPaiement/wave_qr_code.jpg" alt="wave_qr_code">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
import { setTimeout } from 'core-js';
import IntlNumber from '../../common/intlNumber.json'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};
    export default {
        name: 'Faq_section',
        data () {
            return {
                chatReady : false,
                wave_qr_code : false,
                intlNumberData: IntlNumber,
                errors: {},
                step : 0,
                description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
                 ToastTabSucess: { // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                },
                ToastTabError: { // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'error'
                },
                tabs: null,
                user : {
                    countryCode : '+221',
                    telephone : null,
                    question : null
                }
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'Apropos'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },
         methods :{
            openImage(url) {
    window.open(url, '_blank');
},
             initBrevoChat() {
                if (document.getElementById('brevo-chat-script')) return; // éviter doublon

                window.Brevo = function () {
                    (window.Brevo.q = window.Brevo.q || []).push(arguments);
                };

                const script = document.createElement('script');
                script.id = 'brevo-chat-script';
                script.src = 'https://cdn.brevo.com/js/chat-widget.js';
                script.async = true;

                // script.onload = () => {
                //     setTimeout(() => {
                    window.Brevo('init', {
                        apiKey: process.env.VUE_APP_BREVO_CLIENT_KEY,
                    });
                    this.chatReady = true;
                //     }, 2000);
                // };

                document.body.appendChild(script);
            },
            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            sendQuestionBrevo() {
                if (!this.chatReady) {
                    console.log('Le chat Brevo n’est pas encore prêt.');
                    return;
                }
                const message = `Numéro : ${this.user.telephone}\nQuestion : ${this.user.question}`;
                try {
                    //window.Brevo('sendMessage', message, );
                    window.Brevo('sendMessage', {
                    message: message,
                    author: {
                        name: '',
                        email: ''
                    }
                    });
                    this.$toasted.show("Question envoyée à Assuraf avec succès.", this.ToastTabSucess);
                    // this.user.telephone = '';
                    // this.user.question = '';
                } catch (error) {
                    console.error('Erreur lors de l’envoi à Brevo :', error);
                }
            },

            // sendQuestionBrevo() {
            //     console.log('::::: BREVO ::::::', window.Brevo)
            //     const message = `Numéro : ${this.user.telephone}\nQuestion : ${this.user.question}`;

            //     if (window.Brevo) {
            //         window.Brevo('sendMessage', message);
            //     } else {
            //         console.error('Brevo Chat non disponible');
            //     }

            //     // Optionnel : vider le formulaire
            //     this.numero = '';
            //     this.question = '';
            // },



            // sendQuestionBrevo() {
            //     if (!window.Brevo) {
            //         console.error("Brevo n'est pas encore chargé");
            //         return;
            //     }

            //     const numero = this.user.telephone; // depuis v-model
            //     const question = this.user.question; // depuis v-model
            //     const emailUtilisateur = "testtsquestiontestvd@yopmail.com"; // à récupérer depuis l’utilisateur connecté ou le champ

            //     window.Brevo.events.track("form_question_envoyee", {
            //         numero_question: numero,
            //         texte_question: question,
            //         email: emailUtilisateur
            //     });

            //     alert("Question envoyée à Brevo !");
            // },
  
            sendQuestion(){
                if(this.user.telephone) {
                     if(this.user.question){
                        const validPhone = validatePhoneWithIndicatif(this.user.telephone, this.user.countryCode)
                        this.errors.phone = validPhone
                        if(validPhone.valid == true) {
                            this.sendQuestionBrevo()
                    } else {
                        this.$toasted.show("Le numéro n'est pas valide pour l'indicatif sélectionné !", this.ToastTabError);
                    }
                    }else {
                        this.$toasted.show("La question est obligatoire !", this.ToastTabError);
                    }
                }else {
                    this.$toasted.show("Le numéro de téléphone est obligatoire !", this.ToastTabError);
                }
            },
            nextQuestion() {
                if (this.step >= 2) {
                    //this.step = 0; // Reset to first question if at the end
                    return;
                } else {
                    this.step++;
                }
            },
            previousQuestion() {
            if (this.step > 0) {
                this.step--;
            }
            }
         },
        mounted() {
            window.scrollTo(0, 0);
            this.initBrevoChat();

            const items = document.querySelectorAll('.accordion button');
            function toggleAccordion(event) {
                const button = event.currentTarget;
                const itemToggle = button.getAttribute('aria-expanded');

                for (let i = 0; i < items.length; i++) {
                    items[i].setAttribute('aria-expanded', 'false');
                }

                if (itemToggle === 'false') {
                    button.setAttribute('aria-expanded', 'true');
                }
            }

            items.forEach((item) => item.addEventListener('click', toggleAccordion));





        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/config";

    .underline_bar{
        height:4px;
        width: 150px;
        background:#ffa409;
    }
    .underline_bar_for_number{
        height:4px;
        width: 150px;
        background:#fff;
    }
    .titre_for_desktop{
        color: #2b2b2b;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
    }

    .v-tabs__item--active{
        color: #ffa409;
    }
    .mamadou{
        width: 145px;
        height: 600px;
    }
    .article{
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }
    .img-box{
        width: 10%;
        height: 15%;
    }

/* ================================ Fin iframe Mobile ===============================*/
    .titlePolice {
        font-family: Merriweather, Georgia, serif;
        font-weight: 300;
        //color: rgb(74, 74, 74);
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }




















.container {
  margin: 0 auto;
  padding: 4rem;
  width: 60rem;
}

.accordion .accordion-item {
  border-bottom: 1px solid #e5e5e5;
  background-color: #FEFBF6;
      box-shadow: 0 4px 8px rgba(94, 97, 97, 0.1);

  border-radius: 10px;
  margin-top: 10px;
}

.accordion .accordion-item button[aria-expanded='true'] {
  border-bottom: 1px solid #ffa409;
}

.accordion button {
  position: relative;
  display: block;
  text-align: left;
  width: 100%;
  padding: 1em 0;
  color: #2b2b2b;
  font-size: 1.7rem;
  font-weight: 400;
  border: none;
  background: none;
  outline: none;
}

.accordion button:hover,
.accordion button:focus {
  cursor: pointer;
  color: #ffa409;
}

.accordion button:hover::after,
.accordion button:focus::after {
  cursor: pointer;
  color: #ffa409;
  border: 1px solid #ffa409;
}

.accordion button .accordion-title {
  padding: 1em 1.5em 1em 10px;
}

.accordion button .icon {
  display: inline-block;
  position: absolute;
  top: 18px;
  right: 10px;
  width: 22px;
  height: 22px;
  border: 1px solid;
  border-radius: 22px;
      background: #ffa409;
    color: #fff;
}

.accordion button .icon::before {
  display: block;
  position: absolute;
  content: '';
  top: 9px;
  left: 5px;
  width: 10px;
  height: 2px;
  background: currentColor;
  
}
.accordion button .icon::after {
  display: block;
  position: absolute;
  content: '';
  top: 5px;
  left: 9px;
  width: 2px;
  height: 10px;
  background: currentColor;
}

.accordion button[aria-expanded='true'] {
  color: #ffa409;
}
.accordion button[aria-expanded='true'] .icon::after {
  width: 0;
}
.accordion button[aria-expanded='true'] + .accordion-content {
  opacity: 1;
  max-height: max-content;
  transition: all 200ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: opacity 200ms linear, max-height 200ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content p {
  font-size: 1.4rem;
  font-weight: 500;
  margin: 2em 10px;
}



.pagination button {
  background: #ffa409;
  color: #fff;
  border: none;
  margin: 0 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 1.2rem;
  cursor: pointer;
}

input[type="number"] {
  //background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 8px rgba(94, 97, 97, 0.1)!important;
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: #FEFBF6;
  color: #000;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

input[type="number"]::placeholder {
  color: #000;
  font-size: 18px;
}

input[type="text"] {
    box-shadow: 0 4px 8px rgba(94, 97, 97, 0.1)!important;
  //background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: #FEFBF6;
  color: #000;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
  border: 1px solid #e5e5e5;
}

input[type="text"]::placeholder {
  color: #000;
  font-size: 18px;
}

.notfound a {
        font-family: 'Montserrat', sans-serif;
        display: inline-block;
        font-weight: 500;
        text-decoration: none;
        color: #ffa409;
        text-transform :none;
        padding: 13px 23px;
        background: #fff;
        font-size: 15px;
        -webkit-transition: 0.2s all;
        transition: 0.2s all;
    }

    .notfound a:hover {
        color: #fff;
        background: #ffa409;
        border-radius: 30px !important;
    }


    .intl_number {
   border-radius: 10px 0 0 10px;
   height: 56px;
   width: 90px;
   background: #FEFBF6; 
   color: black;
   margin-top:-30px!important;
   font-size: 14px;
   border-bottom: 1px solid #e5e5e5;
   border-top: 1px solid #e5e5e5;
   border-left: 1px solid #e5e5e5;
   box-shadow: 0 4px 8px rgba(94, 97, 97, 0.1)!important;

}
.intl_number:hover {
    border: 1px solid #e5e5e5;
}
.intl_number:focus {
    outline: none;
    border-color: #FEFBF6 !important;
}
    .intl_number:focus::-webkit-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-moz-placeholder {
        color: #000;
    }
    .intl_number:focus:-ms-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-ms-input-placeholder {
        color: #000;
    }

.intl_number::-webkit-input-placeholder {
    color: #000;
}
</style>
